var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _ValidationCtx_valid, _ValidationCtx_errors, _ValidationCtx_warns;
import { validateCore } from "./core";
import { validateCustomMetadata } from "./customMetadata";
export class ValidationCtx {
    constructor() {
        _ValidationCtx_valid.set(this, true);
        _ValidationCtx_errors.set(this, []);
        _ValidationCtx_warns.set(this, []);
    }
    addError(error) {
        __classPrivateFieldGet(this, _ValidationCtx_errors, "f").push(error);
        __classPrivateFieldSet(this, _ValidationCtx_valid, false, "f");
    }
    addWarn(warn) {
        __classPrivateFieldGet(this, _ValidationCtx_warns, "f").push(warn);
    }
    isValid() {
        return __classPrivateFieldGet(this, _ValidationCtx_valid, "f");
    }
    getResult() {
        return {
            valid: __classPrivateFieldGet(this, _ValidationCtx_valid, "f"),
            errors: __classPrivateFieldGet(this, _ValidationCtx_errors, "f"),
            warns: __classPrivateFieldGet(this, _ValidationCtx_warns, "f"),
        };
    }
}
_ValidationCtx_valid = new WeakMap(), _ValidationCtx_errors = new WeakMap(), _ValidationCtx_warns = new WeakMap();
export const validate = ({ item, customSchema }) => {
    const ctx = new ValidationCtx();
    validateCore({ item, ctx, customSchema });
    if (!ctx.isValid)
        return ctx.getResult();
    validateCustomMetadata({ item, ctx, customSchema });
    return ctx.getResult();
};
